import { QR_PASSWORD_MAX_LENGTH, QR_PASSWORD_MIN_LENGTH } from '@/constants'

export const normalizeQrPassword = (value: string) => value.normalize('NFC')

export type TQrPasswordErrors = {
	password?: 'empty' | 'length'
	repeat?: 'mismatch'
}

export const getQrPasswordErrors = (
	password: string,
	repeat: string,
): TQrPasswordErrors => {
	const normalizedPassword = normalizeQrPassword(password)
	const length = [...normalizedPassword].length
	const errors: TQrPasswordErrors = {}

	if (length === 0) {
		errors.password = 'empty'
	} else if (
		length < QR_PASSWORD_MIN_LENGTH ||
		length > QR_PASSWORD_MAX_LENGTH
	) {
		errors.password = 'length'
	}

	if (normalizedPassword !== normalizeQrPassword(repeat)) {
		errors.repeat = 'mismatch'
	}

	return errors
}

export const isQrPasswordValid = (password: string, repeat: string) => {
	const errors = getQrPasswordErrors(password, repeat)
	return !errors.password && !errors.repeat
}
